import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore";
let FillInRange = class FillInRange extends Vue {
  constructor() {
    super(...arguments);
    this.answer1 = "";
    this.answer2 = "";
  }
  dataChage(value) {
    this.zItem = value;
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        this.answer1 = value.answer[0];
        this.answer2 = value.answer[1];
      }
    }
  }
  get questionnaireType() {
    return this.businessType || QuestionnaireEditModule.questionnaireType;
  }
};
__decorate([Prop({
  type: String,
  default: "EDIT"
})], FillInRange.prototype, "viewMode", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], FillInRange.prototype, "zIndex", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], FillInRange.prototype, "showScore", void 0);
__decorate([Prop({
  type: String,
  default: ""
})], FillInRange.prototype, "businessType", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], FillInRange.prototype, "Required", void 0);
__decorate([Watch("zIndex", {
  immediate: true
})
// eslint-disable-next-line
// watchIndex() {}
, Prop({
  type: Object,
  default: {}
})], FillInRange.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], FillInRange.prototype, "dataChage", null);
FillInRange = __decorate([Component({
  name: "fillInRange"
})], FillInRange);
export default FillInRange;